import type { Category } from './categories';
import type { Article } from './articles';

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  color: string;
  videoCount: number;
  articleCount: number;
  featuredImage: string;
  tags: string[];
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '丝瓜视频',
    slug: 'sigua-video',
    description: '丝瓜视频专注提供高清流畅的影视内容，涵盖电影、电视剧、综艺、动漫等多种类型，每日更新最新资源，让您畅享极致观影体验。',
    icon: 'ri-movie-2-line',
    color: '#EF4444',
    videoCount: 2856,
    articleCount: 142,
    featuredImage: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20with%20warm%20cinematic%20lighting%2C%20dark%20elegant%20background%20with%20soft%20gradient%20accents%2C%20film%20reel%20and%20play%20button%20elements%2C%20professional%20video%20platform%20aesthetic%2C%20clean%20minimal%20design%20with%20warm%20orange%20highlights&width=800&height=450&seq=sigua-cat-01&orientation=landscape',
    tags: ['高清影视', '最新电影', '热播剧集', '综艺娱乐'],
  },
  {
    id: 'cat-2',
    name: '蓝莓视频',
    slug: 'blueberry-video',
    description: '蓝莓视频致力于打造精品视频内容平台，汇聚海量正版高清资源，涵盖院线大片、热门剧集、经典老片，为您提供一站式观影服务。',
    icon: 'ri-live-line',
    color: '#F59E0B',
    videoCount: 3421,
    articleCount: 98,
    featuredImage: 'https://readdy.ai/api/search-image?query=Premium%20video%20streaming%20service%20interface%20design%2C%20dark%20themed%20UI%20with%20amber%20gold%20accent%20colors%2C%20movie%20posters%20grid%20layout%2C%20modern%20cinematic%20aesthetic%2C%20luxury%20entertainment%20platform%20concept&width=800&height=450&seq=blueberry-cat-01&orientation=landscape',
    tags: ['正版高清', '院线大片', '热播剧集', '经典回顾'],
  },
  {
    id: 'cat-3',
    name: '糖心视频',
    slug: 'tangxin-video',
    description: '糖心视频以甜蜜温馨的内容为主打，提供海量爱情剧、家庭剧、生活综艺等暖心内容，是您休闲放松的最佳伴侣。',
    icon: 'ri-heart-line',
    color: '#EC4899',
    videoCount: 1892,
    articleCount: 76,
    featuredImage: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20video%20streaming%20app%20interface%2C%20soft%20pink%20and%20rose%20gold%20accents%2C%20romantic%20movie%20collection%20display%2C%20comfortable%20viewing%20experience%20design%2C%20modern%20entertainment%20platform%20with%20heart%20motifs&width=800&height=450&seq=tangxin-cat-01&orientation=landscape',
    tags: ['爱情剧场', '家庭温馨', '生活综艺', '暖心内容'],
  },
  {
    id: 'cat-4',
    name: '黑桃视频',
    slug: 'heitao-video',
    description: '黑桃视频主打悬疑推理、科幻动作类影视内容，精选优质刺激的影片资源，为追求刺激体验的观众提供专属观影空间。',
    icon: 'ri-flashlight-line',
    color: '#8B5CF6',
    videoCount: 1567,
    articleCount: 64,
    featuredImage: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20video%20platform%20interface%2C%20deep%20purple%20and%20black%20theme%2C%20suspense%20thriller%20movie%20collection%2C%20dramatic%20lighting%20effect%2C%20premium%20mystery%20entertainment%20hub%20design&width=800&height=450&seq=heitao-cat-01&orientation=landscape',
    tags: ['悬疑推理', '科幻动作', '惊悚刺激', '烧脑神作'],
  },
  {
    id: 'cat-5',
    name: '妖精视频',
    slug: 'yaojing-video',
    description: '妖精视频聚焦奇幻魔幻类影视作品，汇集国内外优质奇幻剧集、动漫番剧、神话传说改编作品，打开奇幻世界的大门。',
    icon: 'ri-magic-line',
    color: '#10B981',
    videoCount: 1342,
    articleCount: 53,
    featuredImage: 'https://readdy.ai/api/search-image?query=Fantasy%20themed%20video%20streaming%20platform%20design%2C%20magical%20forest%20emerald%20green%20aesthetics%2C%20mythical%20creature%20and%20fantasy%20movie%20collection%2C%20enchanting%20dark%20background%20with%20glowing%20elements&width=800&height=450&seq=yaojing-cat-01&orientation=landscape',
    tags: ['奇幻魔幻', '动漫番剧', '神话传说', '魔法世界'],
  },
  {
    id: 'cat-6',
    name: '桃花视频',
    slug: 'taohua-video',
    description: '桃花视频专注于古装武侠、历史传奇类影视内容，精选经典武侠剧、历史正剧、古装言情，带您穿越古今感受传统文化魅力。',
    icon: 'ri-plant-line',
    color: '#F97316',
    videoCount: 2103,
    articleCount: 87,
    featuredImage: 'https://readdy.ai/api/search-image?query=Classical%20Chinese%20aesthetic%20video%20platform%2C%20traditional%20oriental%20design%20elements%2C%20peach%20blossom%20and%20martial%20arts%20movie%20collection%2C%20warm%20orange%20and%20gold%20tones%2C%20historical%20drama%20streaming%20interface&width=800&height=450&seq=taohua-cat-01&orientation=landscape',
    tags: ['古装武侠', '历史传奇', '经典回顾', '传统文化'],
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((cat) => cat.slug === slug);
};